export default __webpack_public_path__ + "static/media/more-icon.7043f2ba.svg";